/**
 * Created by zhengyf on 2017/12/28.
 */

/**
 *
 */


;(function () {

    dropDownSelectCtrl.$inject = ['$scope', 'event', 'dropDownService'];
    dropDownService.$inject = ['$timeout', 'event'];
    angular
        .module('DSSXAPP')
        .component('dropDownSelect', {
            template:'<div class="ds-component ds-component-dropdown ds-component-drop-down-select" ng-show="vm.showDropDown" ng-style="vm.dropDownStyle"><ul><li class="util-ellipsis" ng-repeat="item in vm.list track by $index" ng-bind="item" ng-click="vm.f.select($event, item)"></li></ul></div>',
            bindings: {
                list: '<',
                showDropDown: '=',
                dropDownStyle: '<',
                onSelect: '&'
            },
            controllerAs: 'vm',
            controller: dropDownSelectCtrl
        })
        .service('dropDownService', dropDownService);

    function dropDownSelectCtrl($scope, event, dropDownService) {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;
        this.$onDestroy = onDestroy;

        var vm = this;

        vm.f = {
            select: select
        }

        function onInit() {
            console.log('[dropDownSelectCtrl init: ]');
            initScopeWatch();
        }

        function onDestroy() {
            event.off('dropDownSelect.update', dropDownSelectOnClose);
        }

        function bindingsOnChanges(changes) {

            if (changes.list) {
                vm.list = vm.list || [];
            }

            if (changes.dropDownStyle) {
                vm.dropDownStyle = vm.dropDownStyle || {width: '132px'};
            }
        }

        function initScopeWatch() {

            event.on('dropDownSelect.close', dropDownSelectOnClose);

            $scope.$watch('vm.showDropDown', function (nv, ov) {
                if (nv) {
                    event.emit('dropDownSelect.close', $scope.$id);
                }
            })
        }

        // 点击一个下拉框，关闭其他下拉框
        function dropDownSelectOnClose(componentId) {
            if (componentId !== $scope.$id) {
                close();
            }
        }

        function close() {
            toggle(false);
        }

        /**
         * toggle 切换下拉框状态
         * @param {boolean} [attr]
         */
        function toggle(attr) {
            if (typeof attr === 'boolean') {
                vm.showDropDown = attr;
                return;
            }
            vm.showDropDown = !vm.showDropDown;
        }

        // 选中下拉菜单
        function select(e, item) {
            // e.stopPropagation();
            vm.onSelect({
                $event: {
                    selectItem: item
                }
            });
        }
    }

    function dropDownService($timeout, event) {
        $(document).click(function () {
            $timeout(function(){
                event.emit('dropDownSelect.close');
            })
        })
    }


})();
